import { useTranslation } from 'react-i18next';
import { ENUM_CUS_EVENT, ENUM_TOAST_TYPE } from '../enums/enums';
import { dispatchCusEvent } from '../utils';

export default function useToast() {
  const { t } = useTranslation();

  const successToast = (mes, dop) => {
    dispatchCusEvent(ENUM_CUS_EVENT.translationToast, {
      message: t(mes),
      type: ENUM_TOAST_TYPE.success,
      ...dop
    });
  };

  const infoToast = (mes, dop) => {
    dispatchCusEvent(ENUM_CUS_EVENT.translationToast, {
      message: t(mes),
      type: ENUM_TOAST_TYPE.info,
      ...dop
    });
  };

  const errorToast = (mes, dop) => {
    dispatchCusEvent(ENUM_CUS_EVENT.translationToast, {
      message: t(mes),
      type: ENUM_TOAST_TYPE.error,
      ...dop
    });
  };

  return {
    successToast,
    errorToast,
    infoToast
  };
}
